import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TermsConditionsDialogOptions } from '@fleet-beat/shared';

@Component({
  selector: 'fb-terms-conditions',
  templateUrl: './terms-conditions-container.component.html',
  styleUrls: ['./terms-conditions-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsConditionsContainerComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public options: TermsConditionsDialogOptions<boolean>) {}
}
